import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.65 2.2 4.1 4.1a.874.874 0 0 0 1.275 0 .875.875 0 0 0 0-1.275L6.275.275A.86.86 0 0 0 5.65 0a.86.86 0 0 0-.625.275l-4.75 4.75A.86.86 0 0 0 0 5.65q0 .35.275.625a.875.875 0 0 0 1.275 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }